import { captureMessage } from '@sentry/react';

import type { PortfolioLinkingSDKError } from '../error/PortfolioLinkingSDKError';

type Args = {
  provider: string;
  brokerage: string;
  flow: 'connection' | 'reconnection';
  error: PortfolioLinkingSDKError;
};
export const capturePortfolioLinkingError = ({
  provider,
  brokerage,
  flow,
  error,
}: Args) => {
  captureMessage('Portfolio Linking Error', {
    extra: {
      error,
    },
    tags: {
      team: 'wombats',
      'portfolio.linking.provider': provider,
      'portfolio.linking.brokerage': brokerage,
      'portfolio.linking.flow': flow,
      'portfolio.linking.sdkErrorCode': error.code,
    },
  });
};
